import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ExportFileTypeCard from '../FileTypeCard';
import { ReactComponent as PDFIcon } from '../assets/pdf-icon.svg';
import { ReactComponent as PDFIconSelected } from '../assets/pdf-icon-selected.svg';
import { ReactComponent as XLSIcon } from '../assets/xls-icon.svg';
import { ReactComponent as XLSIconSelected } from '../assets/xls-icon-selected.svg';
import {
  CURRENT_PAGE_EXPORT,
  PRINT_CURRENT_PAGE,
  RAW_WEEKLY_EXPORT,
  RAW_WEEKLY_EXPORT_DATA,
} from 'utils/strings';

type ExportCardsType = {
  pdfAvailable: boolean;
  exportType: Record<string, boolean>;
  onExportTypeChecked: (id: string) => void;
  onSelection: (id: string) => void;
};

const ExportCards: React.FC<ExportCardsType> = ({
  pdfAvailable,
  exportType,
  onSelection,
  onExportTypeChecked,
}) => {
  return (
    <Row>
      <Col lg={12} md={12}>
        <div className="title">Data Type</div>
      </Col>
      <Col lg={6} md={12}>
        <ExportFileTypeCard
          description={PRINT_CURRENT_PAGE}
          icon={exportType[CURRENT_PAGE_EXPORT] ? <PDFIconSelected /> : <PDFIcon />}
          id={CURRENT_PAGE_EXPORT}
          selected={exportType[CURRENT_PAGE_EXPORT]}
          title="Page Data Only"
          onChange={() => {
            onExportTypeChecked(CURRENT_PAGE_EXPORT);
            !pdfAvailable && onSelection('xls');
          }}
        />
      </Col>
      <Col lg={6} md={12} className="mt-md-3 mt-lg-0">
        <ExportFileTypeCard
          description={RAW_WEEKLY_EXPORT_DATA}
          icon={exportType[RAW_WEEKLY_EXPORT] ? <XLSIconSelected /> : <XLSIcon />}
          id={RAW_WEEKLY_EXPORT}
          selected={exportType[RAW_WEEKLY_EXPORT]}
          title="Raw Weekly Store Data"
          onChange={() => {
            onExportTypeChecked(RAW_WEEKLY_EXPORT);
            onSelection('xls');
          }}
        />
      </Col>
    </Row>
  );
};

export default ExportCards;
